module.exports = __webpack_public_path__ + "static/media/lvjian-ls.a541bdb0.jpg";